import { InMemoryCache, makeVar } from '@apollo/client';
import { gqlCountryEnum as countryType, gqlPurchaseSubscriptionInput, gqlSubscription } from '@minecraft.graphql-types';

// Default country if no Cloudfront Header exists
export const userCountryFromHeaders = makeVar(countryType.US);

export const billingSuccessDetailsVar = makeVar({
  invoiceId: '',
  lastFour: '',
  cardType: '',
  email: '',
  paymentType: '',
  artistId: '',
});

export const subscriptionDetailsVar = makeVar<{
  subscriptionPlanCode: gqlSubscription['plan']['billingCode'];
  subscriptionPlanId?: gqlSubscription['plan']['id'];
  subscriptionPromoCodes?: gqlPurchaseSubscriptionInput['couponCode'][];
  isRenewal?: boolean;
}>({
  subscriptionPlanCode: null,
  subscriptionPlanId: null,
  subscriptionPromoCodes: [],
  isRenewal: false,
});

export const profileAccessTokenVar = makeVar({
  profileAccessTokenId: null,
  organizationId: null,
  artistId: null,
  profileId: null,
});

export const invitationTokenVar = makeVar({
  invitationTokenId: null,
  isCompleted: false,
  isExpired: false,
});

export const forwardRequestInfoVar = makeVar({
  forwardRequestName: null,
  forwardRequestToken: null,
});

export const emailTokenVar = makeVar({
  verifyEmailToken: null,
  message: null,
});

export const cacheConfig = {
  typePolicies: {
    Query: {
      fields: {
        billingPlans: {
          merge: false,
        },
        getBillingInfo: {
          merge: false,
        },
        billingSuccessDetails: {
          read() {
            return billingSuccessDetailsVar();
          },
          merge: true,
        },
        subscription: {
          read() {
            return subscriptionDetailsVar();
          },
          merge: true,
        },
        profileAccessToken: {
          read() {
            return profileAccessTokenVar();
          },
        },
        invitationToken: {
          read() {
            return invitationTokenVar();
          },
        },
        forwardRequestInfo: {
          read() {
            return forwardRequestInfoVar();
          },
        },
        emailToken: {
          read() {
            return emailTokenVar();
          },
        },
        getMediaByArtist: {
          merge(_existing = [], incoming = []) {
            return incoming;
          },
        },
        getSubmissionByRoleProfile: {
          merge(_existing = [], incoming = []) {
            return incoming;
          },
        },
      },
    },
    Role: {
      fields: {
        projectUnion: {
          merge(_existing = [], incoming) {
            return incoming;
          },
        },
      },
    },
    WfRoleMedia: {
      keyFields: ['roleMediaId'],
    },
    Account: {
      fields: {
        billingInfo: {
          merge: true,
        },
      },
    },
    PlanModel: {
      keyFields: (object) => {
        if (object.currency?.id != null) {
          return ['id', 'currency', ['id'], 'price', 'code'];
        }
        return ['id', 'price', 'code'];
      },
    },
    BillingItemModel: {
      keyFields: (object) => {
        const fields = ['id'];
        if (object.price != null) {
          fields.push('price');
        }
        if (object.code != null) {
          fields.push('code');
        }
        if (object.availableCredit != null) {
          fields.push('availableCredit');
        }
        return fields;
      },
    },
  },
};

export const buildCache = () => new InMemoryCache(cacheConfig);

export default buildCache();
